import {dispatcher} from 'store/helpers';
import * as actions from './actions';

export * from './actions_legacy';
export * from './selectors';
export * from './ui-selectors';
export const dispatch = dispatcher(actions);
